import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon, GiftIcon, RotateCcwIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { pricing, packIncludes, bonusShortList } from '../data/offer';
const reassurances = [{
  icon: ShieldCheckIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: GiftIcon,
  label: '5 bonos incluidos'
}, {
  icon: RotateCcwIcon,
  label: 'Garantía de devolución de 7 días'
}];
export function OfferSection() {
  return <section id="comprar" aria-labelledby="incluye-titulo" className="w-full bg-cream-100" data-id="element-154" data-mp="meabf7hk5avs">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-20 lg:py-28" data-id="element-155" data-mp="rdemk3o1lior">
        <div className="max-w-2xl" data-id="element-156" data-mp="wczj67fqpeyb">
          <h2 id="incluye-titulo" className="font-display text-2xl font-extrabold leading-tight tracking-tight text-forest-900 sm:text-4xl" data-id="element-157" data-mp="wbyb8bu0t8kt">
            Todo lo que incluye tu compra
          </h2>
          <p className="mt-3 text-[15px] text-forest-800/75 sm:mt-4 sm:text-lg" data-id="element-158" data-mp="2y4mdahuxhpz0">
            Acceso inmediato a todo esto por un único pago.
          </p>
        </div>

        <div className="mt-7 grid gap-5 sm:mt-12 sm:gap-8 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14" data-id="element-159" data-mp="xvqs3qb4myaq">
          <div className="order-2 rounded-xl bg-cream-50 p-5 sm:rounded-2xl sm:p-9 lg:order-1" data-id="element-160" data-mp="syql9d6gdrik">
            <div className="flex items-start justify-between gap-5 border-b border-cream-300 pb-5 sm:gap-6 sm:pb-6" data-id="element-161" data-mp="ox53peiz4p21">
              <div data-id="element-162" data-mp="1lluobclzjvrp">
                <h3 className="font-display text-base font-extrabold uppercase tracking-wide text-forest-900 sm:text-xl" data-id="element-163" data-mp="1lka0e5u6fb2t">
                  MegaPack Hábitos
                </h3>
                <ul className="mt-3 space-y-1.5 sm:mt-4 sm:space-y-2" data-id="element-164" data-mp="1ck4vq3gdaqsc">
                  {packIncludes.map(item => <li key={item} className="flex gap-2.5 text-sm text-forest-800 sm:gap-3 sm:text-[15px]" data-id="element-165" data-mp="17oxxhb5vaeat">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-moss-600 sm:mt-1" aria-hidden="true" data-id="element-166" data-mp="3scu2y14kp1rt" />
                      <span data-id="element-167" data-mp="3trwqssrfuz46">{item}</span>
                    </li>)}
                </ul>
              </div>
              <span className="shrink-0 font-display text-base font-bold tabular-nums text-forest-900 sm:text-lg" data-id="element-168" data-mp="3ktbaz5dcpy73">
                {pricing.today}
              </span>
            </div>

            <ul className="divide-y divide-cream-200" data-id="element-169" data-mp="3owr96652k6lw">
              {bonusShortList.map((bonus, index) => <li key={bonus} className="flex items-center justify-between gap-4 py-2.5 sm:py-4" data-id="element-170" data-mp="3fu89tw0hsc4e" data-mpi={index}>
                  <span className="flex min-w-0 items-baseline gap-2 text-sm sm:block sm:text-[15px]" data-id="element-171" data-mp="315lsxpv7vcb2">
                    <span className="font-display text-[10px] font-bold uppercase tracking-wider text-moss-600 sm:text-xs" data-id="element-172" data-mp="3645ehp5wem2w">
                      Bono #{index + 1}
                    </span>
                    <span className="truncate font-medium text-forest-900 sm:mt-0.5 sm:block sm:overflow-visible" data-id="element-173" data-mp="2x3qqgi1jusvp">
                      {bonus}
                    </span>
                  </span>
                  <span className="shrink-0 font-display text-[10px] font-bold uppercase tracking-wider text-moss-600 sm:text-xs" data-id="element-174" data-mp="28iu6vohpphj3">
                    Gratis
                  </span>
                </li>)}
              <li className="flex items-center justify-between gap-4 py-2.5 sm:py-4" data-id="element-175" data-mp="2igibr79185ez">
                <span className="flex items-baseline gap-2 text-sm sm:block sm:text-[15px]" data-id="element-176" data-mp="2wgjd0nt7leuz">
                  <span className="font-display text-[10px] font-bold uppercase tracking-wider text-moss-600 sm:text-xs" data-id="element-177" data-mp="2rhq1h0xhfxxg">
                    Garantía
                  </span>
                  <span className="font-medium text-forest-900 sm:mt-0.5 sm:block" data-id="element-178" data-mp="368p1voo5zg5y">
                    Garantía de 7 días
                  </span>
                </span>
                <span className="shrink-0 font-display text-[10px] font-bold uppercase tracking-wider text-moss-600 sm:text-xs" data-id="element-179" data-mp="3f82g0un8gsx0">
                  Incluida
                </span>
              </li>
            </ul>

            <div className="mt-1 flex items-center justify-between border-t border-cream-300 pt-4 text-sm text-forest-800/70 sm:mt-2 sm:pt-5 sm:text-[15px]" data-id="element-180" data-mp="18is0u44owe1s">
              <span data-id="element-181" data-mp="1i8lc140x6r5i">Valor total regular</span>
              <span className="font-display tabular-nums line-through" data-id="element-182" data-mp="1i9mxm2fkaw1h">{pricing.totalValue}</span>
            </div>
          </div>

          <div className="order-1 flex flex-col justify-center rounded-xl bg-forest-900 p-5 text-cream-100 sm:rounded-2xl sm:p-9 lg:order-2" data-id="element-183" data-mp="pkfqwg5yf055">
            <p className="text-xs uppercase tracking-[0.16em] text-moss-400 sm:text-sm sm:tracking-[0.18em]" data-id="element-184" data-mp="uk25ou1fkog2">
              Hoy pagás solamente
            </p>
            <div className="mt-2 flex flex-wrap items-baseline gap-3 sm:mt-3" data-id="element-185" data-mp="13jp91ldq04br">
              <p className="font-display text-[2.75rem] font-extrabold leading-none tracking-tight text-cream-50 sm:text-6xl" data-id="element-186" data-mp="13hkvebq0rqya">
                {pricing.today}
              </p>
              <span className="rounded-full bg-forest-700 px-3 py-1 font-display text-xs font-bold text-moss-200 sm:text-sm" data-id="element-187" data-mp="2ex9hz1zd2nyk">
                Ahorrás {pricing.savings}
              </span>
            </div>
            <p className="mt-2 text-[13px] text-moss-200 sm:text-sm" data-id="element-188" data-mp="2k614wavbtmf1">
              Precio único · Acceso de por vida
            </p>

            <div className="mt-5 sm:mt-8" data-id="element-189" data-mp="2bbw3wymhauls">
              <CtaButton variant="inverse" data-id="element-190" data-mp="2bb4lkphw6tdg">Comprar y empezar ahora</CtaButton>
            </div>

            <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs text-moss-200 sm:mt-6 sm:grid-cols-1 sm:gap-y-2 sm:text-sm" data-id="element-191" data-mp="26dcmnbity6zr">
              {reassurances.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-1.5 sm:gap-2" data-id="element-192" data-mp="1wevpfwtasw59">
                  <Icon className="h-3.5 w-3.5 shrink-0 text-moss-400 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-193" data-mp="1sdtonbjqgc16" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}